import React from 'react';

// Testo di un documento da sottoscrivere (regolamento), impaginato come un foglio.
// Segni semplici, scritti dallo staff nell'editor (mai HTML: si disegna tutto con React, niente da iniettare):
//   # Titolo          ## Sottotitolo / articolo
//   - voce di elenco  1. voce numerata
//   **grassetto**     *corsivo*
//   ---  nuova pagina          riga vuota = nuovo paragrafo
const inline = (t, k) => {
  const pezzi = [];
  const re = /\*\*(.+?)\*\*|\*(.+?)\*/g;
  let ultimo = 0, m, n = 0;
  while ((m = re.exec(t))) {
    if (m.index > ultimo) pezzi.push(t.slice(ultimo, m.index));
    pezzi.push(m[1] !== undefined ? <b key={`${k}b${n++}`}>{m[1]}</b> : <i key={`${k}i${n++}`}>{m[2]}</i>);
    ultimo = re.lastIndex;
  }
  if (ultimo < t.length) pezzi.push(t.slice(ultimo));
  return pezzi;
};

// righe → blocchi (titolo, sottotitolo, paragrafo, elenco, nuova pagina)
export const blocchi = (testo) => {
  const out = [];
  let par = null, lista = null;
  const chiudi = () => { par = null; lista = null; };
  for (const riga of String(testo || '').split('\n')) {
    const r = riga.trim();
    let m;
    if (!r) { chiudi(); continue; }
    if (/^-{3,}$/.test(r)) { chiudi(); out.push({ t: 'pagina' }); continue; }
    if ((m = r.match(/^(#{1,2})\s+(.*)$/))) { chiudi(); out.push({ t: m[1].length === 1 ? 'h1' : 'h2', x: m[2] }); continue; }
    if ((m = r.match(/^[-•]\s+(.*)$/)) || (m = r.match(/^(\d+)[.)]\s+(.*)$/))) {
      const num = m.length === 3;
      const voce = num ? m[2] : m[1];
      if (!lista || lista.num !== num) { par = null; lista = { t: 'lista', num, inizio: num ? +m[1] : 1, voci: [] }; out.push(lista); }
      lista.voci.push(voce);
      continue;
    }
    lista = null;
    if (par) par.righe.push(r); else { par = { t: 'p', righe: [r] }; out.push(par); }
  }
  return out;
};

export default function TestoImpaginato({ testo }) {
  return blocchi(testo).map((b, i) => {
    if (b.t === 'pagina') return <div key={i} className="fv-foglio-salto" aria-hidden="true" />;
    if (b.t === 'h1') return <h2 key={i} className="fv-foglio-h1">{inline(b.x, i)}</h2>;
    if (b.t === 'h2') return <h3 key={i} className="fv-foglio-h2">{inline(b.x, i)}</h3>;
    if (b.t === 'lista') {
      const Tag = b.num ? 'ol' : 'ul';
      return <Tag key={i} start={b.num && b.inizio !== 1 ? b.inizio : undefined}>{b.voci.map((v, k) => <li key={k}>{inline(v, `${i}_${k}`)}</li>)}</Tag>;
    }
    return <p key={i}>{b.righe.map((r, k) => <React.Fragment key={k}>{k > 0 && <br />}{inline(r, `${i}_${k}`)}</React.Fragment>)}</p>;
  });
}
